import { useImage } from "./Image.hook"
import { useEffect, useState } from "react"

type ImgOptimizedProps = {
    src: string
    alt?: string
    width?: number | string
    height?: number | string
    className?: string
    title?: string
    imageId?: string
    propertyId?: string
    loading?: "lazy" | "eager"
}

export const ImagenOptimizada = ({ src, alt = "", width, height, className = "", title, imageId, propertyId, loading }: ImgOptimizedProps) => {
    const { getImagenOptimizada, getSrcSet, notifyError } = useImage()
    const [hasError, setHasError] = useState(false)
    const [srcSetFailed, setSrcSetFailed] = useState(false)
    useEffect(() => setSrcSetFailed(false), [src])
    const defaultImg = 'https://cdn4.fincaraiz.com.co/web/66575677eea43_screenshot-2024-05-29-at-11.20.20.png'

    const srcUrl = getImagenOptimizada({
        src: src ?? '',
        width: width ?? 1,
        height: height ?? 1
    })

    const srcSet = getSrcSet({ src: src ?? '', width, height })

    const handleError = () => {
        // Si falló un candidato de 2x/3x, primero se reintenta con la URL de 1x.
        if (srcSet && !srcSetFailed) return setSrcSetFailed(true)
        setHasError(true)
        notifyError({
            image_url: src,
            image_id: imageId,
            property_id: propertyId
        })
    }

    const useFallback = hasError || !srcUrl || srcUrl.length === 0
    const finalSrc = useFallback ? defaultImg : srcUrl

    return <img 
        src={finalSrc}
        srcSet={useFallback || srcSetFailed ? undefined : srcSet}
        alt={alt}
        width={width ?? 'auto'}
        height={height ?? 'auto'}
        className={className}
        title={title}
        loading={loading}
        onError={handleError}
    />
}